import axios, { AxiosResponse } from "axios";
import axiosClient from "@/shared/lib/axios/axios.ts";
import { API_ROUTES } from "@/auth/api/config.ts";
import { ApiResponse } from "@/shared/types/api.ts";

// Separate axios instance for auth requests - no interceptors to avoid refresh loops
const authAxiosClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: false,
});

export interface IForgotPasswordInput {
  email: string;
}
export const forgotPassword = async (data: IForgotPasswordInput) => {
  return axiosClient.post(`${API_ROUTES.FORGOT_PASSWORD}`, data).then((data) => data.data);
};


export interface ILoginInput {
    username: string;
    password: string;
}

export interface ILoginResponse {
   access: string;
   refresh: string;

}

export interface IAcceptInput {
    token: string;
    password: string;
}

export interface IAcceptResponse {
   access: string;
   refresh: string;

}

export const login = async (data: ILoginInput) => {
  // Use plain axios client for login - no auth token needed
  return authAxiosClient.post<ILoginInput, AxiosResponse<ApiResponse<ILoginResponse>>>(API_ROUTES.LOGIN, data).then((data) => data.data);
}

export const acceptInvite = async (data: IAcceptInput) => {
  return authAxiosClient.post<IAcceptInput, AxiosResponse<ApiResponse<IAcceptResponse>>>(API_ROUTES.ACCEPT_INVITE, data).then((data) => data.data);
}

export interface IRefreshTokenInput {
  refresh: string;
}

export interface IRefreshTokenResponse {
  access: string;
  refresh: string;
}


// Use authAxiosClient to avoid interceptors - prevents 401 loop on refresh endpoint
export const refreshToken = async (data: IRefreshTokenInput) => {
  return authAxiosClient.post<IRefreshTokenInput, AxiosResponse<ApiResponse<IRefreshTokenResponse>>>(API_ROUTES.REFRESH, data).then((data) => data.data);
}